export default __webpack_public_path__ + "static/media/cryptographic_data_mesh_ad.69457ce5.png";